/**
 * The limits of an account's email and password (ADR-013, P1.4-T2; ADR-064's amendment "accounts have no
 * account name": an account is an email and a password). They sit beside the character-name rule because the
 * gateway and the login screen read the same definitions: the gateway refuses a registration past them, and
 * each field of the login screen stops the typing at them, since a field longer than the gateway takes would
 * build a body past the gateway's listener cap, which Bun refuses with a 413 carrying no CORS headers, so the
 * page could only report that the server did not answer. The shape of an email is the gateway's to judge.
 */

/**
 * Longest email address accepted, the limit of an SMTP path.
 */
export const MAX_EMAIL_CHARS = 254;

/**
 * Shortest password accepted. There is no composition rule: length is the only requirement.
 */
export const MIN_PASSWORD_CHARS = 8;

/**
 * Longest password accepted, so a request cannot make the password hasher chew through a megabyte.
 */
export const MAX_PASSWORD_CHARS = 200;
